import { jsx as _jsx } from "react/jsx-runtime";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { sitePhotoGroupStore } from "../../../stores/appConfig/sitePhotoGroupStore";
import { textFieldStyle } from "../../../assets/styles/styles";
import { sitePhotoStore } from "../../../stores/appConfig/sitePhotoStore";
export const GroupSelector = ({ value, onChange }) => {
    const options = Array.from(new Set(sitePhotoGroupStore.useData().map(i => i.group)));
    return (_jsx(Autocomplete, { sx: {
            maxWidth: 500,
            ...textFieldStyle
        }, multiple: true, freeSolo: true, limitTags: 3, filterSelectedOptions: true, value: value, options: options, getOptionLabel: (option) => `${option}`, onChange: onChange, renderInput: (params) => (_jsx(TextField, { ...params, variant: "standard", label: "Select Group", placeholder: "Categories" }, void 0)) }, void 0));
};
export const SelectGroup = () => {
    const value = sitePhotoStore.useNewSitePhotoGroups();
    return (_jsx(GroupSelector, { value: value, onChange: (_event, newValue) => {
            sitePhotoStore.setNewSitePhoto({ ...sitePhotoStore.getNewSitePhoto(), groups: newValue });
        } }, void 0));
};
//# sourceMappingURL=SelectGroup.js.map